import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  ProgressNodeFocusEnum,
  ProgressNodeStatusEnum,
  ProgressNodeTypeEnum,
} from '../../enums';
import { BaseNodeComponent } from '../base-node/base-node.component';
import { ActivityService } from 'src/app/shared/services';

@Component({
  selector: 'htc-progress-node',
  templateUrl: './progress-node.component.html',
  styleUrls: ['./progress-node.component.scss'],
  standalone: false,
})
export class ProgressNodeComponent
  extends BaseNodeComponent
  implements OnInit, OnDestroy
{
  readonly path = '/assets/progress-node-icons/';
  type = ProgressNodeTypeEnum.progressNodeComp;
  focusClass = '';
  statusClass = '';
  sub!: Subscription;

  constructor(
    private activityService: ActivityService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.sub = new Subscription();
    if (this.focus$) {
      this.sub.add(
        this.focus$.subscribe((value: number | undefined) => {
          if (value !== undefined) {
            this.onFocusChange(value);
          }
        })
      );
    }

    if (this.status$) {
      this.sub.add(
        this.status$.subscribe((value: number | undefined) => {
          if (value !== undefined) {
            this.onStatusChange(value);
          }
        })
      );
    }
  }

  /**
   * On focus change set the class of progress node element
   * @param  {ProgressNodeFocusEnum} focus state to set focus to
   */
  onFocusChange(focus: ProgressNodeFocusEnum): void {
    switch (focus) {
      case ProgressNodeFocusEnum.active:
        this.focusClass = 'active';
        break;
      case ProgressNodeFocusEnum.seen:
        this.focusClass = 'seen';
        break;
      default:
        this.focusClass = '';
        break;
    }
    this.cdr.markForCheck();
  }

  /**
   * On status change set image url of element
   * @param  {ProgressNodeStatusEnum} status state to set status to
   */
  onStatusChange(status: ProgressNodeStatusEnum): void {
    switch (status) {
      case ProgressNodeStatusEnum.wrong:
        this.statusClass = 'wrong';
        break;
      case ProgressNodeStatusEnum.correct:
        this.statusClass = 'correct';
        break;
      case ProgressNodeStatusEnum.perfect:
        this.statusClass = 'perfect';
        break;
      case ProgressNodeStatusEnum.complete:
        this.statusClass = 'complete';
        break;
      default:
        this.statusClass = '';
        break;
    }
    this.cdr.markForCheck();
  }

  onNodeClicked(): void {
    if (this.clickedEmitter && !this.disabled) {
      this.clickedEmitter.emit({
        index: this.index,
        type: this.type,
        data: this.data,
        focus: this.focus$.getValue() ?? 0,
        status: this.status$.getValue() ?? 0,
      });
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public get isPreK2Reading(): boolean {
    return this.activityService.isPreK2ReadingActivity();
  }
}
